import angular from 'angular';

import Component from './entity-content.component';

const Module = angular
    .module('control-room.commons.form.components.entity-content', [])
    .component('crEntityContent', Component);

export default Module;
